var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D78EEF15-2FBD-4C85-8BE1-F5C4BEB90A2D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Page---",
    transform: "translate(-21.000000, -149.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(-1.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "process",
    transform: "translate(22.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.73480261,2.98828125 C2.47807193,2.98828125 3.09344981,2.44954644 3.21273131,1.74316406 L6.13253843,1.74316406 L5.80920378,2.0651439 L6.16281956,2.41727798 L7.08984375,1.49414062 L6.16282206,0.571003271 L5.80920628,0.923137354 L6.13254093,1.24511719 L3.21273381,1.24511719 C3.09344981,0.538734814 2.47807193,0 1.73480261,0 C0.906136446,0 0.234375,0.66894668 0.234375,1.49414062 C0.234375,2.31933457 0.906136446,2.98828125 1.73480261,2.98828125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8817785,1.2450735 L10.2378596,1.2450735 C10.1188708,0.538715911 9.50500272,0 8.763557,0 C7.93692397,0 7.26681068,0.668923207 7.26681068,1.4940882 C7.26681068,2.31925319 7.93692397,2.9881764 8.763557,2.9881764 C9.50500272,2.9881764 10.1188708,2.44946048 10.2378596,1.7431029 L11.8817785,1.7431029 C13.3261487,1.7431029 14.5010846,2.91607419 14.5010846,4.35775724 C14.5010846,5.7994403 13.3261487,6.97241159 11.8817785,6.97241159 L7.86901659,6.97241159 L8.19155793,6.65044305 L7.83880975,6.29832133 L6.9140625,7.22142629 L7.83880975,8.14453125 L8.19155793,7.79240952 L7.86901659,7.47044099 L11.8817785,7.47044099 C13.6011858,7.47044099 15,6.07411098 15,4.35775724 C15,2.6414035 13.6011858,1.2450735 11.8817785,1.2450735 L11.8817785,1.2450735 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.2714844,
    cy: 12.9785156,
    r: 1.49414062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24652136,11.484375 C5.4178552,11.484375 4.74609375,12.1533217 4.74609375,12.9785156 C4.74609375,13.8037096 5.4178552,14.4726562 6.24652136,14.4726562 C6.98979068,14.4726562 7.60516856,13.9339214 7.72445006,13.2275391 L10.6442572,13.2275391 L10.3209225,13.5495189 L10.6745383,13.901653 L11.6015625,12.9785156 L10.6745408,12.0553783 L10.320925,12.4075124 L10.6442597,12.7294922 L7.72445256,12.7294922 C7.60516856,12.0231098 6.98979068,11.484375 6.24652136,11.484375 L6.24652136,11.484375 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.11957465,13.2126285 L3.6401543,13.2126285 L3.31747298,13.534597 L3.67037424,13.8867188 L4.59552279,12.9636138 L3.67037424,12.0405088 L3.31747298,12.3926306 L3.6401543,12.7145991 L3.11957465,12.7145991 C1.67457769,12.7145991 0.499131944,11.5416278 0.499131944,10.0999447 C0.499131944,8.65826169 1.67457769,7.4852904 3.11957465,7.4852904 L3.76594303,7.4852904 C3.88498351,8.19164798 4.49912044,8.7303639 5.24088542,8.7303639 C6.06787717,8.7303639 6.73828125,8.06144069 6.73828125,7.2362757 C6.73828125,6.41111071 6.06787717,5.7421875 5.24088542,5.7421875 C4.49911795,5.7421875 3.88498351,6.28090341 3.76594303,6.987261 L3.11957465,6.987261 C1.39942122,6.987261 0,8.383591 0,10.0999447 C0,11.8162985 1.39942122,13.2126285 3.11957465,13.2126285 L3.11957465,13.2126285 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.e026e22e52b9477cb972e71f6b2bd346.svg";
export { ForwardRef as ReactComponent };